import { getStore } from "app/store/store"
import { CAMPAIGN_STATUSES_RUNNING_OR_RUNNED } from "campaign/model"
import { ALL_SUMMARY_TABS, IForm, SUMMARY_TABS } from "form/model"
import { formActionCreator } from "form/store/actions"

export function getAllSummaryTabs(): SUMMARY_TABS[] {
  return ALL_SUMMARY_TABS.slice()
}

export function getAvailableSummaryTabs(form: IForm): SUMMARY_TABS[] {
  if (
    form.context.isForecast ||
    form.context.isDspDeal ||
    form.context.isCreation ||
    !CAMPAIGN_STATUSES_RUNNING_OR_RUNNED.includes(form.statusId)
  ) {
    return [SUMMARY_TABS.PARAMETERS]
  }
  return getAllSummaryTabs()
}

export function activateSummaryTab(form: IForm, tab: SUMMARY_TABS): void {
  if (form.activeSummaryTab === tab) {
    return
  }
  if (!getAvailableSummaryTabs(form).includes(tab)) {
    console.error(`Unable to activate tab "${tab}" for form. Availables: ${getAvailableSummaryTabs(form)}`)
    return
  }
  getStore().dispatch(formActionCreator.setActiveSummaryTab(form.context.appContext, tab))
}
